<style scoped>
.chips-container {
  border-style: inset;
  min-height: 56px;
  padding: 8px;
}
.chip-item {
  margin: 4px;
}
.no-padding {
  border-radius: 0px;
  padding: 0px;
}
</style>

<template>
  <mu-chip class="chip-item" @click="onClickPlay" :delete="!isSubmitted" @delete="onDelete" v-if="fetched">
    <mu-icon value="play_arrow" /> {{computedDuration}}
  </mu-chip>
</template>

<script>
import langEn from './lang/en.json'
import langZh from './lang/zh.json'

import axios from "axios";

import timeFormatter from '@/utils/timeFormatter.js'

export default {
  name: 'AttachmentItem',
  components: {

  },
  props: {
    isSubmitted: {
      type: Boolean,
      default: false
    },
    attachment: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      // Object
      blob: null,
      fetched: false,
      audio: null,
    }
  },
  computed: {
    computedDuration() {
      return timeFormatter(this.attachment.duration / 1000);
    }
  },
  watch: {
    attachment: {
      handler(newValue) {
        this.onFetchBlob();
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.$i18n.add('en', langEn);
    this.$i18n.add('zh', langZh);
    this.initAudio();
    this.onFetchBlob();
  },
  methods: {
    initAudio() {
      this.audio = document.createElement("audio");
      this.audio.controls=true;
      document.body.appendChild(this.audio);
    },
    onFetchBlob() {
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + 'file?path=' + this.attachment.path,  // apiUrl is the server api url and path is the path of file to download in server
        headers: {
          token: this.$store.state.auth.token
        },
        responseType: 'arraybuffer' // Important attribute for response to create a blob for download
      }).then(res => {
        let b = new Blob([res.data], { type: this.attachment.mimetype }); // Create a blob, mimetype is a variable to indicate the type of file, such as "text/plain" for json files
        let a = window.URL.createObjectURL(b)
        this.blob = a;
        this.audio.src = this.blob;
        this.fetched = true;
      });
    },
    onDelete() {
      this.$emit('onDelete');
    },
    onClickPlay() {
      this.audio.play();
    },

    isAudio(type) {
      return type === 'audio/mpeg';
    }
  },
}
</script>
